import React, {useState} from 'react'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'
import i18n from '../../../assets/i18n'
import {Card, CardHeader, CardContent, Tooltip, Badge} from "@material-ui/core";
import {DraftsRounded, MailRounded} from "@material-ui/icons";
import {generatePath} from "react-router";
import routes from "../../../config/routes";
import {Link} from "react-router-dom";
import {OfferStateImage} from "../index";
import OfferCandidatureStatusType from "../../../models/offer-candidature-status-type";
import OfferCardStyled from "./styled";
import {ButtonWithIcon, DeleteIcon} from "../../atoms";
import ActionDialog from "../action-dialog";
import {deletePushOffer} from "../../../api";
import {toast} from "react-toastify";

function OfferCard({item, filters}) {
  const [showOfferDeleteModal, setShowOfferDeleteModal] = useState(false);

  const date_from = item.date_from.split('T')[0].split("-").reverse().join("/");
  const date_to = item.date_to.split('T')[0].split("-").reverse().join("/");

  const formattedDateTo = date_to.split("/");
  const isExpired = new Date(formattedDateTo[2] + '/' + formattedDateTo[1] + '/' + formattedDateTo[0]) <= new Date();
  const interested_count_color = item.interested > 0 ? '#34ab11' : '#da0000';
  const wasRead = item.was_read;

  const filterTags = Object.keys(filters).map((filter, index) => {
    let filterData = filters[filter][0];
    return <button key={index} id={index} className="btn card_container__card-content-button">
      {'filter' in filterData && filterData.filter !== undefined && 'name' in filterData.filter && filterData.filter.name}: {filterData.label}
    </button>

  }).reverse();

  const handleCloseShowOfferDeleteModal = () => setShowOfferDeleteModal(false);
  const handleOpenShowOfferDeleteModal = (e) => {
    e.preventDefault();
    setShowOfferDeleteModal(true);
  }

  // Devuelve la promesa: spinner en Eliminar y el modal se cierra cuando la petición va bien
  const handleOnClickDelete = () => {
    return deletePushOffer(item.id).then(() => {
      handleCloseShowOfferDeleteModal();
      toast.success(i18n.offerCard.delete.success);
      window.location.reload();
    }).catch(() => {
      toast.error(i18n.offerCard.delete.error);
    });
  }

  function handleDeleteButton() {
    return handleOnClickDelete();
  }

  return (
    <div>
    <Link to={{
      pathname: generatePath(routes.offerCandidatures, {slug: item.id}),
    }}>
      <OfferCardStyled>
        <div className="col-lg-3 col-md-6 col-xs-12 card_container">
          <Card className={"card_container__card " + (isExpired ? 'expired_push_offer' : '')}>
            <CardHeader
              className="card_container__card-header"
              title={
                <>
                  {wasRead
                    ? <DraftsRounded color={"action"} fontSize="large"/>
                    : <MailRounded color={"primary"} fontSize="large"/>
                  }
                  <span>{item.name}</span>
                  <ButtonWithIcon remove='true'
                                  onClick={handleOpenShowOfferDeleteModal}
                                  isDeleteOfferBtn={true}
                                  Icon={<DeleteIcon/>}/>
                </>
              }
              subheader={
                <>
                            <span className="card_container__card-header-date_range">
                                {date_from + ' - ' + date_to}
                            </span>
                  <span className="card_container__card-header-interested">
                                <span
                                  style={{color: interested_count_color}}>{item.interested} {i18n.offerCard.interested_candidatures}</span>
                                <span className="state-icons">
                                    <Badge badgeContent={String(item.interested)} color="primary"><OfferStateImage
                                      state={OfferCandidatureStatusType.INTERESTED}></OfferStateImage></Badge>
                                    <Badge badgeContent={String(item.not_interested)} color="primary"><OfferStateImage
                                      state={OfferCandidatureStatusType.NOT_INTERESTED}></OfferStateImage></Badge>
                                    <Badge badgeContent={String(item.unanswered)} color="primary"><OfferStateImage
                                      state={OfferCandidatureStatusType.UNANSWERED}></OfferStateImage></Badge>
                                </span>
                            </span>
                </>
              }
            />
            <CardContent className="card_container__card-content">
              <div className="card_container__card-content-description">
                <Tooltip title={item.description_without_html}>
                  <p className="card_container__card-content-description-text"
                     dangerouslySetInnerHTML={{__html: item.description}}>
                  </p>
                </Tooltip>
              </div>
              <div className="card_container__card-content-filters">{filterTags}</div>
            </CardContent>
          </Card>
        </div>
      </OfferCardStyled>
    </Link>
    <ActionDialog
      open={showOfferDeleteModal}
      title={`${i18n.modalDeleteUser.removeUser} "${item.name}"`}
      onClose={handleCloseShowOfferDeleteModal}
      onConfirm={handleDeleteButton}
      cancelLabel={i18n.dialog.decline}
      confirmLabel={i18n.modalDeleteUser.remove}
      confirmColor="error"
      maxWidth="xs"
    >
      <p style={{margin: 0, textAlign: 'center'}}>{i18n.process.deleteModalText}</p>
    </ActionDialog>
  </div>
  )
}

OfferCard.propTypes = {
  item: PropTypes.object.isRequired,
}

const enharce = compose()

export default enharce(OfferCard)
